import styles from "./StatCard.module.css";

const TONE_CLASS = {
  neutral: styles.neutral,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
};

export const StatCard = ({ label, value, tone = "neutral", icon: Icon, isLoading }) => {
  return (
    <div className={styles.statCard}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        {!!Icon && (
          <span className={`${styles.iconWrap} ${TONE_CLASS[tone]}`}>
            <Icon size={16} strokeWidth={2} aria-hidden />
          </span>
        )}
      </div>
      {isLoading ? (
        <div className={styles.valueSkeleton} />
      ) : (
        <span className={styles.value}>{value}</span>
      )}
    </div>
  );
};
